export const LABELS_ADD_ROW = 'LABELS_ADD_ROW';
export const LABELS_DELETE_ROW = 'LABELS_DELETE_ROW';
export const LABELS_UPDATE_ROW = 'LABELS_UPDATE_ROW';
export const LABELS_COPY_ROW = 'LABELS_COPY_ROW';
export const LABELS_DELETE_ALL = 'LABELS_DELETE_ALL';
export const LABELS_PRINT_ALL = 'LABELS_PRINT_ALL';
export const LABELS_FINISHED_PRINTING = 'LABELS_FINISHED_PRINTING';
export const LABELS_SET_PAGE = 'LABELS_SET_PAGE';
